// extracted by mini-css-extract-plugin
export default {"loader":"ywrQRiDT0ee9bnuIijNL","fade":"Ziis7kgoRoW5jufeW1Gg","expandBigger":"EaQl44P8UlcjeRek59sr","expandTiny":"mTGtUxhcsHEGVFSDiHy5","expandBiggest":"aTlLpixuZv59u11hLXa7"};